import React from 'react';
import styled from 'styled-components';
import {withLoginRequired} from 'rev.sdk.js/Components/LoginRequired';
import LoginRequired from '../LoginRequired';
import SiteNavBar from '../SiteNavBar';

function DetailLayout(props) {
  return (
    <>
      <NavBar>
        <div className="maxwidth-container">
          <div className="logo-box">
            <img
              src="/images/site-logo.png"
              alt="Logo"
              style={{
                height: 40,
                objectFit: 'contain',
              }}
            />
          </div>
        </div>
      </NavBar>
      {props.children}
    </>
  );
}

// export default withLoginRequired(DetailLayout, {
//   admin: false,
//   SiteNavBar,
//   renderLoginRequired: LoginRequired,
// });

export default DetailLayout;

const NavBar = styled.div`
  position: fixed;
  background-color: white;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: var(--topNavBarHeight);
  padding: 0px 40px;

  display: flex;
  align-items: center;

  z-index: 101;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  transition: 200ms;

  &:hover {
    box-shadow: 0 5px 12px rgba(0, 0, 0, 0.16);
  }

  & > .maxwidth-container {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: var(--contentMaxWidth);
    width: 100%;
    margin: 0 auto;
  }

  & > .maxwidth-container > .logo-box {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
`;
